import { useRouter } from "next/router";
import React from "react";
import { FC, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import SEOTags from "~/components/SEOTags";
import { PATH } from "~/constants/enum";
import Layout from "~/layouts/ThemeLayout";
import userAtom from "~/services/user/user.atom";
import { getPageStruct, renderPage } from "~/utils/page";
import { renderSectionByKey } from "~/utils/pageTwo";
import { getTheme } from "~/utils/theme";

const SignUpPage: FC = () => {
  const pageStruct = getPageStruct(getTheme(), "sign-up");
  //   const [component, setComponent] = useState<any>();
  const user = useRecoilValue(userAtom.currentUser);
  const router = useRouter();

  // useEffect(() => {
  //     async function fetchComponent() {
  //         const component = await renderPage(
  //             pageStruct.children.sort((a: any, b: any) => a.order - b.order),
  //             getTheme()
  //         );
  //         setComponent(component.filter((c) => !!c));
  //     }

  //     fetchComponent();
  // }, [pageStruct.children]);

  const sections: any = pageStruct?.children
    ?.sort((a: any, b: any) => a.order - b.order)
    .map((item: any) => {
      const Section = renderSectionByKey(item.id);

      return {
        id: item.id,
        order: item.order,
        dataKey: item.dataKey,
        identifier: item.identifier,
        component: Section ?? null,
      };
    });

  useEffect(() => {
    if (user?.token) {
      router.push(PATH.ProfileInformation);
    }
  }, [user?.token]);

  return (
    <Layout>
      <SEOTags title="Sign up" />
      {sections.map((section: any, index: number) => {
        const Section = section.component;
        return (
          <React.Fragment key={`section-${index}`}>
            {React.isValidElement(Section) ? (
              React.cloneElement(Section as React.ReactElement, {})
            ) : (
              <Section />
            )}
          </React.Fragment>
        );
      })}
    </Layout>
  );
};

export default SignUpPage;
